jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 3,
  scroll: 2,
});

new Swiper("#swiper3", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  // loop: true,
  // centeredSlides: true,
  // slidesPerView: "auto",
  spaceBetween: 60,
  pagination: {
    clickable: true,
    el: ".pagination1",
  },
});
new Swiper("#swiper4", {
  // autoplay: true,
  // autoplay: {
  //   disableOnInteraction: false,
  // },
  // loop: true,
  // centeredSlides: true,
  // slidesPerView: "auto",
  spaceBetween: 60,
  pagination: {
    clickable: true,
    el: ".pagination2",
  },
});
let spImgList = [];
let spImgList1 = [
  "https://cdn.shopifycdn.net/s/files/1/0555/2783/3705/files/202406290-img5.webp",
  "https://cdn.shopifycdn.net/s/files/1/0555/2783/3705/files/202406290-img5-2.webp",
  "https://cdn.shopifycdn.net/s/files/1/0555/2783/3705/files/202406290-b1.webp",
  "https://cdn.shopifycdn.net/s/files/1/0555/2783/3705/files/202406290-b2.webp",
  "https://cdn.shopifycdn.net/s/files/1/0555/2783/3705/files/202406290-b3.webp",
  "https://cdn.shopifycdn.net/s/files/1/0555/2783/3705/files/202406290-b4.webp",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);
    setTimeout(function(){
      let cCWidth = $(window).width();
      if(cCWidth < 749){
        console.log("////",scale)
        $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",Math.floor(scale *　10));
      }else{
        $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",scale *　1);
      }
    },300)
    

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          let cWidth = $(window).width();
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
            if(cWidth < 749){
              $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",Math.floor(scale *　10));
            }else{
              $('.ribbons-extensions-theme-plugins-app-embed-plus').css("zoom",scale *　1);
            }
            
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(spImgList1);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            238 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
    let id = $(this).attr('data-id')
    let price = window.product.filter(item=> item.id == id)[0].price / 100
    let compare = window.product.filter(item=> item.id == id)[0].compare_at_price / 100
    price = (price * input.value).toFixed(2)
    compare = (compare * input.value).toFixed(2)
    price = '€' + (price + '').replace('.', ',')
    compare = '€' + (compare + '').replace('.', ',')
    $(this).parents(".product-box").find(".price1").html(price);
    $(this).parents(".product-box").find(".price2").html(compare);
  }
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  let id = $(this).attr('data-id')
    let price = window.product.filter(item=> item.id == id)[0].price / 100
    let compare = window.product.filter(item=> item.id == id)[0].compare_at_price / 100
    price = (price * input.value).toFixed(2)
    compare = (compare * input.value).toFixed(2)
    price = '€' + (price + '').replace('.', ',')
    compare = '€' + (compare + '').replace('.', ',')
    $(this).parents(".product-box").find(".price1").html(price);
    $(this).parents(".product-box").find(".price2").html(compare);
});


$('.sp_buy_now').on('click',function(){
  let id = $(this).attr('data-id');
  let num = $(this).siblings('.addGroup').find('input').val();
  window.location.href = '/cart/' + id + ':' + num
})